<template>
  <div class="search-bar">
    <TextInput
      ref="input"
      v-bind="$attrs"
      v-on="inputListeners"
      :disabled="disabled"
      @keydown.enter="onSearch"
      @compositionstart="isComposing = true"
      @compositionend="isComposing = false"
    />
    <button class="search-button" @click="onSearch" :disabled="disabled" />
  </div>
</template>

<script>
import TextInput from '@/components/atoms/TextInput'

/**
 * 検索バー
 */
export default {
  name: 'SearchBar',
  components: {
    TextInput,
  },
  props: {
    disabled: Boolean,
  },
  data() {
    return {
      isComposing: false,
    }
  },
  computed: {
    inputListeners() {
      return {
        ...this.$listeners,
        input: value => {
          /**
           * 文字入力
           * @event input
           * @type {string}
           */
          this.$emit('input', value)
        },
      }
    },
  },
  methods: {
    onSearch() {
      if (this.isComposing) return
      /**
       * 検索実行
       *
       * @event search
       * @type {string}
       */
      this.$emit('search', this.$refs.input.value.trim())
    },
  },
}
</script>

<style lang="postcss" scoped>
.search-bar {
  align-items: center;
  border-color: var(--border-color);
  border-style: solid;
  display: flex;
  width: 488px;

  .input-text {
    border-color: inherit;
    border-style: inherit;
    font-size: 13px;
    padding-right: 56px;

    &:focus {
      border-color: var(--dark-gray);
    }
  }
}

.search-button {
  appearance: none;
  background: url(/assets/img/icons/search.png) no-repeat center transparent;
  background-size: 17px 17px;
  border: 0;
  border-color: inherit;
  border-left-width: 1px;
  border-style: inherit;
  cursor: pointer;
  display: block;
  height: 40px;
  margin: 0 0 0 -56px;
  padding: 0;
  width: 56px;

  &:disabled {
    cursor: auto;
  }

  .input-text:focus + & {
    border-left-color: var(--dark-gray);
  }
}
</style>
